import { makeStyles } from '@material-ui/styles';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import flattenChildren from 'react-keyed-flatten-children';
import { useResponsivePropRecord } from "../props/ResponsiveProp.js";
import { jsx as _jsx } from "react/jsx-runtime";
var PREVENT_COLLAPSE = 1;
function spaceVariant(theme, space) {
  var gap = theme.spacing(space);
  return {
    '&:before': {
      marginTop: -gap - PREVENT_COLLAPSE
    },
    '& > $container': {
      marginLeft: -gap,
      '& > $child > $childContainer': {
        marginTop: gap,
        marginLeft: gap
      }
    }
  };
}
function columnVariant(columns) {
  return {
    flex: "0 0 ".concat(100 / columns, "%")
  };
}
var useStyles = /*#__PURE__*/makeStyles(theme => ({
  root: {
    paddingTop: PREVENT_COLLAPSE,
    '&:before': {
      content: '""',
      display: 'block',
      marginTop: -PREVENT_COLLAPSE
    }
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  child: {
    minWidth: 0
  },
  childContainer: {
    height: '100%'
  },
  space1: spaceVariant(theme, 1),
  space2: spaceVariant(theme, 2),
  space3: spaceVariant(theme, 3),
  space4: spaceVariant(theme, 4),
  space5: spaceVariant(theme, 5),
  space6: spaceVariant(theme, 6),
  space7: spaceVariant(theme, 7),
  space8: spaceVariant(theme, 8),
  space9: spaceVariant(theme, 9),
  space10: spaceVariant(theme, 10),
  columns1: columnVariant(1),
  columns2: columnVariant(2),
  columns3: columnVariant(3),
  columns4: columnVariant(4),
  columns5: columnVariant(5),
  columns6: columnVariant(6)
}), {
  name: 'SD-Tiles'
});
export var Tiles = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
    children,
    space: spaceProp = 1,
    columns: columnsProp = 1
  } = _ref;
  var styles = useStyles({});
  var space = useResponsivePropRecord(spaceProp);
  var columns = useResponsivePropRecord(columnsProp);
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    className: clsx(styles.root, {
      [styles.space1]: space === 1,
      [styles.space2]: space === 2,
      [styles.space3]: space === 3,
      [styles.space4]: space === 4,
      [styles.space5]: space === 5,
      [styles.space6]: space === 6,
      [styles.space7]: space === 7,
      [styles.space8]: space === 8,
      [styles.space9]: space === 9,
      [styles.space10]: space === 10
    }),
    children: /*#__PURE__*/_jsx("div", {
      className: styles.container,
      children: flattenChildren(children).map((child, idx) => /*#__PURE__*/_jsx("div", {
        className: clsx(styles.child, {
          [styles.columns1]: columns === 1,
          [styles.columns2]: columns === 2,
          [styles.columns3]: columns === 3,
          [styles.columns4]: columns === 4,
          [styles.columns5]: columns === 5,
          [styles.columns6]: columns === 6
        }),
        children: /*#__PURE__*/_jsx("div", {
          className: styles.childContainer,
          children: child
        })
      }, idx))
    })
  });
});
if (process.env.NODE_ENV !== "production") Tiles.displayName = "Tiles";